import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyToClipboardComponent } from './components/copy-to-clipboard/copy-to-clipboard.component';
import { PanelCardComponent } from '../shared-components/panel-hub/panel-card/panel-card.component';
import { PanelListComponent } from './components/panel-list/panel-list.component';
import { LayoutComponent } from './components/layout/layout.component';
import { PanelModule } from 'primeng/panel';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button'; 
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { ErrorComponent } from './components/error/error.component';
import { LabelComponent } from '../shared-components/label/label.component';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageComponent } from './components/message/message.component';
import { DialogModule } from 'primeng/dialog';
import { TreeComponent } from './components/tree/tree.component';
import { TreeModule } from 'primeng/tree';
import { ToastModule } from 'primeng/toast';
import { FileIconComponent } from './components/file-icon/file-icon.component';
import { ReadOnlyComponent } from './components/read-only/read-only.component';
import { BptLayoutModule } from 'bpt-ui-library/bpt-layout';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { SelectUserComponent } from './components/select-user/select-user.component';
import { AuditLifeCycleComponent } from './components/audit-life-cycle/audit-life-cycle.component';
import {FieldsetModule} from 'primeng/fieldset';
import {SpeedDialModule} from 'primeng/speeddial';
import { SpeedDialComponent } from './components/speed-dial/speed-dial.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MessagesModule } from 'primeng/messages';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { ConfirmationDialogComponent } from './components/dialog/confirmation-dialog/confirmation-dialog.component';
import { AuditAttributeDetailsComponent } from './components/audit-item-details/audit-item-details.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';
import { StatCardDataComponent } from './components/stat-card-data/stat-card-data.component';
import { SafePipe } from './pipe/safe.pipe';
import { TrainingTabComponent } from './components/training-tab/training-tab.component';
import { QuizCompletionComponent } from '../shared-components/quiz-completion/quiz-completion.component';
import { BptEmptyFeedbackResultsModule } from 'bpt-ui-library/bpt-empty-feedback-results';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component'
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptMenuButtonModule } from 'bpt-ui-library/bpt-menu';
import { RelatedDocumentDetailsComponent } from './components/related-document-details/related-document-details.component';
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';
import { TrainingItemGroupManagementComponent } from './components/training-item-group-management/training-item-group-management.component';
import { BlurOnSearchDirective } from './directives/blur-on-search.directive';
import { PdfPreviewComponent } from './components/pdf-preview/pdf-preview.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RemovalReasonDialogComponent } from './components/dialog/removal-reason-dialog/removal-reason-dialog.component';
import { RevocationDialogComponent } from './components/dialog/revocation-dialog/revocation-dialog.component';
import { CurriculumTrainingItemGroupManagementComponent } from './components/curriculum-training-item-group-management/curriculum-training-item-group-management.component';
import { UnassignTrainingItemGroupSliderComponent } from './components/unassign-training-item-group-slider/unassign-training-item-group-slider.component';
import { UpdateTreeComponent } from './components/update-tree/update-tree.component';

@NgModule({
  declarations: [
    PreventDoubleClickDirective,
    BlurOnSearchDirective,
    CopyToClipboardComponent,
    LayoutComponent,
    PanelListComponent,
    ErrorComponent,
    MessageComponent,
    TreeComponent,
    UpdateTreeComponent,
    FileIconComponent,
    ReadOnlyComponent,
    TopBarComponent,
    NavBarComponent,
    SelectUserComponent,
    AuditLifeCycleComponent,
    SpeedDialComponent,
    DialogComponent,
    ConfirmationDialogComponent,
    AuditAttributeDetailsComponent,
    DialogComponent,
    ConfirmationComponent,
    StatCardComponent,
    StatCardDataComponent,
    SafePipe,
    TrainingTabComponent,
    RelatedDocumentDetailsComponent,
    TrainingItemGroupManagementComponent,
    PdfPreviewComponent,
    CurriculumTrainingItemGroupManagementComponent,
    UnassignTrainingItemGroupSliderComponent,
    RemovalReasonDialogComponent,
    RevocationDialogComponent
  ],
  imports: [
    CommonModule,
    PanelModule,
    MenubarModule,
    MessagesModule,    
    InputTextModule,
    ButtonModule,
    MultiSelectModule,
    FormsModule,
    CheckboxModule,
    DialogModule,
    TreeModule,
    BptLayoutModule,
    ToastModule,
    BptDropdownModule,
    FieldsetModule,   
    SpeedDialModule,
    BptTextInputModule,
    QuizCompletionComponent,
    BptEmptyFeedbackResultsModule,
    BptProgressSpinnerModule,
    BptMenuButtonModule,
    PdfViewerModule,
    EmptyResultsComponent,
    SpinnerComponent,
    PanelCardComponent,
    LabelComponent

  ],
  exports: [
    PreventDoubleClickDirective,
    BlurOnSearchDirective,
    CopyToClipboardComponent,
    LayoutComponent,
    PanelListComponent,
    ErrorComponent,
    MessageComponent,
    TreeComponent,
    TreeModule,
    UpdateTreeComponent,
    FileIconComponent,
    ReadOnlyComponent,
    TopBarComponent,
    NavBarComponent,
    SelectUserComponent,
    SpeedDialModule,
    FieldsetModule,
    SpeedDialComponent,
    AuditLifeCycleComponent,
    DialogComponent,
    ConfirmationDialogComponent,
    AuditAttributeDetailsComponent,
    ConfirmationComponent,
    StatCardComponent,
    StatCardDataComponent,
    SafePipe,
    TrainingTabComponent,
    RelatedDocumentDetailsComponent,
    TrainingItemGroupManagementComponent,
    PdfPreviewComponent,
    CurriculumTrainingItemGroupManagementComponent,
    UnassignTrainingItemGroupSliderComponent,
    RemovalReasonDialogComponent,
    RevocationDialogComponent
    ]
})
export class SharedModule { }
